// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__2+iv5","tyre":"style_tyre__mXFc-"};